import React from 'react';

import { IconTypes } from '@eika/icon';
import { LinkCard } from '@eika/link-panel';

import { useConfig } from '../../defaultConfig';
import useAccountId from '../../hooks/useAccountId';
import { useTranslation } from '../../translations';
import { format } from '../../translations/useTranslation';
import { kredittbankenTrackingIDs } from '../../utils/gtm/kredittbankenTrackingIds';

const LoanActionLinks: React.FC = () => {
    const translated = useTranslation();
    const accountId = useAccountId();
    const {
        links: { changePaymentDateLink, seeDocumentsLink },
    } = useConfig();

    return (
        <>
            {changePaymentDateLink?.url && accountId && (
                <LinkCard
                    title={translated.loanOverview.changeDate}
                    textOne={translated.loanOverview.atKredittbanken}
                    icon={IconTypes.PENN_24}
                    url={format(changePaymentDateLink.url, accountId.toString())}
                    data-track-id={kredittbankenTrackingIDs.loanOverviewActions}
                    data-track-linkname={translated.loanOverview.changeDate}
                />
            )}
            {seeDocumentsLink?.url && accountId && (
                <LinkCard
                    title={translated.loanOverview.seeDocuments}
                    textOne={translated.loanOverview.atKredittbanken}
                    icon={IconTypes.PENN_24}
                    url={format(seeDocumentsLink.url, accountId.toString())}
                    data-track-id={kredittbankenTrackingIDs.loanOverviewActions}
                    data-track-linkname={translated.loanOverview.seeDocuments}
                />
            )}
        </>
    );
};

export default LoanActionLinks;
